import actionTypes from '../constants/action-types';
import generateId from '../helpers/generate-id';

const createPage = ({
  html,
  locale,
  displayInNavigation = false,
  usedBlocks = [],
  pageTemplateId = null,
  recipeId = null,
  isMultilingualSite,
  name = null,
  skipActivePageChange = false,
  displayBusinessName = null,
  parentFolderId = null,
}) => ({
  type: actionTypes.CREATE_PAGE,
  payload: {
    html,
    locale,
    displayInNavigation,
    usedBlocks,
    pageId: generateId(),
    recipeId,
    pageTemplateId,
    isMultilingualSite,
    name,
    skipActivePageChange,
    displayBusinessName,
    parentFolderId,
  },
});

export default createPage;
